<div class="relative my-4">
  @if (!available()) {
    <div class="absolute z-10 flex h-full w-full items-center justify-center pb-8">
      <span class="typo-h3-medium">{{ 'perio_exam_path_coming_soon' | translate }}</span>
    </div>
  }
  <div class="rounded-lg border" (click)="onCardClick()" [ngClass]="classList()">
    @if (selected()) {
      <div class="absolute -right-3 -top-3 aspect-square h-6 w-6 rounded-full bg-secondary-green">
        <svg-icon key="px-24-tick" class="text-text-white"></svg-icon>
      </div>
    }

    <div class="relative">
      @for (examDirection of perioExamDirection().items; track examDirection.label) {
        <div
          class="absolute aspect-square h-6 overflow-visible"
          [class.-left-1]="examDirection.side === 'left'"
          [class.-right-1]="examDirection.side === 'right'"
          [ngStyle]="{ 'top.px': examDirection.slot }"
        >
          <lib-perio-exam-carousel-orb [examDirection]="examDirection" />
        </div>
      }

      <img ngSrc="assets/images/perio/exam-path.svg" [height]="132" [width]="250" alt="exam-path" />
    </div>
  </div>
</div>
